
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1429"}},[_c('path',{attrs:{"data-name":"Rectangle 1478","fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M20.64 12.205a10.341 10.341 0 00-.164-1.841H12v3.481h4.844a4.14 4.14 0 01-1.796 2.719v2.256h2.908a8.777 8.777 0 002.684-6.615z","fill":"#4285f4"}}),_c('path',{attrs:{"data-name":"Shape","d":"M12 21a8.592 8.592 0 005.957-2.18l-2.91-2.259a5.409 5.409 0 01-3.048.859 5.364 5.364 0 01-5.035-3.71H3.957v2.332A9 9 0 0012 21z","fill":"#34a853"}}),_c('path',{attrs:{"data-name":"Shape","d":"M6.964 13.71a5.321 5.321 0 010-3.42V7.958H3.957a9.011 9.011 0 000 8.084l3.007-2.332z","fill":"#fbbc05"}}),_c('path',{attrs:{"data-name":"Shape","d":"M12 6.58a4.862 4.862 0 013.44 1.346l2.581-2.581A8.649 8.649 0 0012 3a9 9 0 00-8.043 4.958l3.007 2.332A5.364 5.364 0 0112 6.58z","fill":"#ea4335"}}),_c('path',{attrs:{"data-name":"Shape","d":"M3 3h18v18H3z","fill":"none"}})])])
          )
        }
      }
    